"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Gemeinde model module.
 * @module model/Gemeinde
 * @version 0.0.1
 */
class Gemeinde {
  /**
   * Constructs a new <code>Gemeinde</code>.
   * @alias module:model/Gemeinde
   * @param name {String} 
   * @param id {Number} 
   */
  constructor(name, id) {
    Gemeinde.initialize(this, name, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, id) {
    obj['name'] = name;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>Gemeinde</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Gemeinde} obj Optional instance to populate.
   * @return {module:model/Gemeinde} The populated <code>Gemeinde</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Gemeinde();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Gemeinde</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Gemeinde</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of Gemeinde.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    return true;
  }
}
Gemeinde.RequiredProperties = ["name", "id"];

/**
 * @member {String} name
 */
Gemeinde.prototype['name'] = undefined;

/**
 * @member {Number} id
 */
Gemeinde.prototype['id'] = undefined;
var _default = exports.default = Gemeinde;